import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const PhasesStyled = styled.div`
  .sectionSecond {
    display: flex;
    flex-direction: column;
    gap: 16px;

    & h3 {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.4;
      color: ${color.text.primary};
      margin: 0;
    }

    & p {
      font-size: 14px;
      font-weight: 400;
      line-height: 1.5;
      color: ${color.text.tertiary};
      margin: 0;
    }
  }

  .sectionHeader {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .formField {
    display: flex;
    flex-direction: column;

    label {
      font-size: 14px;
      font-weight: 500;
      line-height: 1.4;
      color: ${color.text.label};
      margin-bottom: 8px;
      ::after {
        content: '*';
        color: ${color.error.main};
        padding-left: 2px;
      }
    }
  }

  .containerButtonForm {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    width: 100%;
  }

  .containerDragAndDropList {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }

  .MuiCircularProgress-root {
    width: 24px !important;
    height: 24px !important;
  }
`
